<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase">
        <span class="font-weight-light hidden-sm-and-down" style="text-overflow: visible">ORG OWL</span>
      </v-toolbar-title>
        <v-img
          contain
          @click="$router.push('/')"
          :src="require('./assets/logo2.png')"
          height="55px"
        ></v-img>
      <v-btn
        text
        style="background-color: rgba(249, 191, 59, 1)"
        to="/demo"
      >
        <span class="mr-2">Demo</span>
        <v-icon>fas fa-project-diagram</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    //
  }),
  methods: {
    scrollToBottom: function() {
      window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
    }
  }
};
</script>
